import { useEffect, useState } from "react";
import CustomModel from "../../Utility/CustomModel";

export const RefAuthorGroup = ({
  handleCancel,
  editor,
  show,
  refId,
  setData,
  authGroup,
  setAuthGroup,
}) => {
  const fields = [
    {
      name: "sur-name",
      label: "Surname",
      type: "text",
      default: "",
      editable: true,
    },
    {
      name: "given-name",
      label: "Given Name",
      type: "text",
      default: "",
      editable: true,
    },
  ];
  const [authorData, setAuthorData] = useState([]);

  const handleChange = (e, i) => {
    const { name, value } = e.target;
    setAuthorData((prev) =>
      prev.map((item, index) =>
        index === i ? { ...item, [name]: value } : item
      )
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const combinedAuthors = authorData
      .map((author) => {
        return Object.values(author)
          .filter((val) => val && val.trim() !== "")
          .join(" ");
      })
      .join(", ");

    setData((prevData) => ({
      ...prevData,
      "person-group": combinedAuthors,
    }));
    setAuthGroup(authorData);
    handleCancel();
  };

  const handleAddAuthor = (index) => {
    const emptyAuthor = fields.reduce((acc, field) => {
      acc[field.name] = field?.default || "";
      return acc;
    }, {});
    setAuthorData((prevData) => {
      const newData = [...prevData];
      newData.splice(index + 1, 0, { ...emptyAuthor }); // insert after current
      return newData;
    });
   
  };

  const handleRemoveAuthor = (index) => {
    setAuthorData((prevData) => {
      if (prevData.length === 1) return prevData; // Prevent deleting the last row
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
    
  };
  

  useEffect(() => {
    if (refId && authGroup.length>0) {

      setAuthorData(authGroup);
    } else{
      const initial = fields.reduce((acc, field) => {
        acc[field.name] = field?.default || "";
        return acc;
      }, {});

      setAuthorData([initial]);
    }
  }, []);

  return (
    <div className="w-fit h-fit">
      <CustomModel
        handleCancel={handleCancel}
        heading={show.value ? "Author Edit" : "author Create"}
        width={"80%"}
        show={show.open}
      >
        <div className="w-full h-full max-h-[80vh] overflow-y-auto">
        <form onSubmit={handleSubmit} className="w-full h-full p-4  ">
          {authorData.length ? (
            authorData.map((data, i) => (
              <div className="flex gap-4 mb-4 items-end w-full">
                {fields.map((field, index) => {
                  const isEditable = field.editable || false;

                  const isTrulyReadOnly = !field.editable;

                  const inputStyle = {
                    padding: "2px 10px",
                    flexGrow: 1,
                    ...(isTrulyReadOnly
                      ? {
                          border: "none",
                          outline: "none",
                          backgroundColor: "#f9f9f9",
                        }
                      : { border: "1px solid #ccc", outline: "none" }),
                  };

                  return (
                    <div key={index} className=" flex flex-col gap-2">
                      <label className="ref-form-label min-w-[200px]">
                        {field.label}
                      </label>

                      <input
                        type={field.type}
                        name={field.name}
                        value={data[field.name]}
                        onChange={(e) => handleChange(e, i)}
                        style={inputStyle}
                        readOnly={!isEditable}
                      />
                    </div>
                  );
                })}
                <div className="flex justify-end  gap-2 w-fit">
                  <button
                  type="button"
                    className="px-4 py-1 border border-grey text-nowrap"
                    onClick={() => handleAddAuthor(i)}
                  >
                    Add Row
                  </button>
                  <button
                  type="button"
                    className="px-4 py-1 border border-grey text-nowrap"
                    onClick={() => handleRemoveAuthor(i)}
                    disabled={authorData.length === 1}
                  >
                    Delete Row
                  </button>
                </div>
              </div>
            ))
          ) : (
            <></>
          )}
          <div className="ml-auto w-full">
            <div className="flex py-3 ml-auto gap-4 justify-end">
              <button
                className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
                onClick={() => handleCancel()}
              >
                {" "}
                Cancel
              </button>
              <button
                className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
                onClick={(e) => handleSubmit(e)}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
        </div>
      </CustomModel>
    </div>
  );
};
